import { render, staticRenderFns } from "./ElTagInput.vue?vue&type=template&id=32bc7c9c"
import script from "./ElTagInput.vue?vue&type=script&lang=js"
export * from "./ElTagInput.vue?vue&type=script&lang=js"
import style0 from "./ElTagInput.vue?vue&type=style&index=0&id=32bc7c9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports